<!--
 * @Author: your name
 * @Date: 2022-04-01 17:09:53
 * @LastEditTime: 2022-04-07 11:32:59
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \admin_kakaclo_front_end\src\views\dashboard\dashboard\components\timeSelect.vue
-->
<template>
    <div class="form">
        <el-date-picker
            v-model="dateValues"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="margin-right: 10px"
            @change="dateChange"
            :clearable="false"
            :picker-options="pickerOptions">
        </el-date-picker>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    name: 'timeSelect',
    data() {
        const that = this
        return {
            dateValues: [moment().subtract('days', 6), moment()],
            selectValue: '最近7日',
            pickerOptions: {
                disabledDate(time) {
                    let maxTimeCanSelect = 31 * 24 * 3600 * 1000
                    let isInRange = time.getTime() > that.minDate ? time.getTime() - that.minDate > maxTimeCanSelect : that.minDate - time.getTime() > maxTimeCanSelect
                    return time.getTime() > Date.now() || (that.minDate && isInRange);
                },
                shortcuts: [
                    {
                        text: '最近7日',
                        onClick() {
                            that.timeSelect('最近7日')
                        }
                    },
                    {
                        text: '今日',
                        onClick() {
                            that.timeSelect('今日')
                        }
                    },
                    {
                        text: '昨日',
                        onClick() {
                            that.timeSelect('昨日')
                        }
                    },
                    {
                        text: '最近15日',
                        onClick() {
                            that.timeSelect('最近15日')
                        }
                    },
                    {
                        text: '最近30日',
                        onClick() {
                            that.timeSelect('最近30日')
                        }
                    },
                    {
                        text: '上月',
                        onClick() {
                            that.timeSelect('上月')
                        }
                    }
                ],
                onPick({maxDate, minDate}) {
                    if(!maxDate && minDate) {
                        that.minDate = minDate.getTime()
                    }
                }
            },
            minDate: 0
        }
    },
    mounted() {
        this.$emit('timeChange', this.dateValues, true)
    },
    methods: {
        dateChange() {
            this.$emit('timeChange', this.dateValues.map(t=>moment(t)))
        },
        timeSelect(value) {
            switch (value) {
                case '最近7日':
                    this.dateValues = [moment().subtract('days', 6), moment()]
                    break;
                case '今日':
                    this.dateValues = [moment(), moment()]
                    break;
                case '昨日':
                    this.dateValues = [moment().subtract('days', 1), moment().subtract('days', 1)]
                    break;
                case '最近15日':
                    this.dateValues = [moment().subtract('days', 14), moment()]
                    break;
                case '最近30日':
                    this.dateValues = [moment().subtract('days', 29), moment()]
                    break;
                case '上月':
                    this.dateValues = [moment().subtract(1,'months').startOf('month'), moment().subtract(1,'months').endOf('month')]
                    break
                case '自定义':
                    break
                default:
                    break;
            }
            this.$emit('timeChange', this.dateValues)
        }
    },
}
</script>